module.exports = __webpack_public_path__ + "img/topicEnergy.0047976e.webp";